import { DoorOpen, Timer, WifiOff, Route } from "lucide-react";

export const FEATURE_DEFS = [
  ["leave_desk", "Leave Desk", "Allow stepping away from the desk / site during duty", DoorOpen],
  ["overtime_requests", "Overtime Requests", "Submit and track overtime hours for approval", Timer],
  ["offline_mode", "Offline Mode", "Capture clock-ins offline and sync when back online", WifiOff],
  ["journey_history", "Employee Journey History", "View travel history & the site-visit timeline", Route],
];

export const DEFAULT_FEATURES = { leave_desk: true, overtime_requests: true, offline_mode: true, journey_history: true };

export function normalizeFeatures(f) {
  const src = f || {};
  return FEATURE_DEFS.reduce((acc, [k]) => ({ ...acc, [k]: src[k] === undefined ? true : !!src[k] }), {});
}

export default function FeatureToggles({ value, onChange, note }) {
  const feats = normalizeFeatures(value);
  const toggle = (k) => onChange({ ...feats, [k]: !feats[k] });
  return (
    <div data-testid="feature-toggles">
      <label className="block text-xs font-semibold text-slate-500 uppercase mb-2">Feature Access</label>
      <div className="space-y-2">
        {FEATURE_DEFS.map(([k, label, hint, Icon]) => {
          const on = feats[k];
          return (
            <button
              key={k}
              type="button"
              data-testid={`feature-${k}`}
              aria-pressed={on}
              onClick={() => toggle(k)}
              className={`flex items-center gap-3 w-full px-3 py-2.5 rounded-lg border transition text-left ${on ? "bg-indigo-50 border-indigo-300" : "bg-white border-slate-200"}`}
            >
              <span className={`grid place-items-center h-8 w-8 rounded-lg flex-shrink-0 ${on ? "bg-indigo-600 text-white" : "bg-slate-100 text-slate-400"}`}>
                <Icon className="h-4 w-4" />
              </span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-slate-700">{label}</span>
                <span className="block text-[11px] text-slate-400 leading-snug">{hint}</span>
              </span>
              <span className={`relative inline-flex h-5 w-9 flex-shrink-0 rounded-full transition ${on ? "bg-indigo-500" : "bg-slate-300"}`}>
                <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-all ${on ? "left-4" : "left-0.5"}`} />
              </span>
            </button>
          );
        })}
      </div>
      <p className="mt-2 text-xs text-slate-400">{note || "When a feature is off, it is completely hidden from this user in the app and portal."}</p>
    </div>
  );
}
